import React from "react"

export default React.createContext({
  userouter: false,
  basePath: null
});
